import { Check } from 'lucide-react';

import type { McqContent, ScriptElement } from '@/lib/schema.types';
import { cn, stripInlineMcqOptions } from '@/lib/utils';

export function McqElement({ element }: { element: ScriptElement }) {
  const c = element.content as McqContent | undefined;
  if (!c) return null;
  // Guard against generators that repeat the choices inside the question text —
  // the options already render as their own A/B/C/D rows below.
  const question = stripInlineMcqOptions(c.question, c.options);
  return (
    <div className="w-full text-left text-fg">
      <div
        className="mb-2 font-medium text-[#1f2937]"
        style={{ fontSize: (element.style?.fontSize as number | undefined) ?? 16 }}
      >
        {question}
      </div>
      <ul className="space-y-1.5">
        {c.options.map((opt, i) => (
          <li
            key={i}
            className={cn(
              'flex items-center gap-2 rounded-md border border-black/10 bg-white/60 px-2.5 py-1.5 text-sm text-[#374151]',
              i === c.answerIndex && 'border-emerald-400/60 bg-emerald-50',
            )}
          >
            <span className="grid h-5 w-5 place-items-center rounded-full bg-black/5 text-[10px] font-medium">
              {String.fromCharCode(65 + i)}
            </span>
            <span className="flex-1">{opt}</span>
            {i === c.answerIndex && <Check size={14} className="text-emerald-600" />}
          </li>
        ))}
      </ul>
    </div>
  );
}
